import React, { Component } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import { CMSPath } from '../../../config/constant'
import { playDoorCameraStream } from '../../../JS/playDoorCameraStream'
import {
  popupOpenClose, browserListPopup,
  currentWidget, setDeviceConfigFailed, setRegPage, setFailScreen
} from "../../../action/action"
import {
  HashRouter,
  Link,
  Redirect
} from 'react-router-dom'
import { navItemsConstant } from '../../../config/layout2constant'
import { setHcommerceWidget } from '../../action/hCommerce2'
import { inAppBrowser } from '../../JS/inAppBrowser'
import { sendAnalytics } from "../../../action/homeAction"
import { setExternalSignIn, setLoader, setLoginRequired , setOpenExternalLinkInSameTab} from "../../action/homeAction"
import { getCdnUrl } from '../../../config/config';

class PromoWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPromoWidget: {},
      secondPromoWidget:null,
      dataAvailable: true,
      promoWidgets: [],
      timeoutIn: false,
      widgetMatch: {},
      secondWidgetMatch: null,
      timeoutInstance: setTimeout( () => {})
    }
  }

  /*static getDerivedStateFromProps(props, state) {
    let timeO = false
    let currentPromo = state.currentPromoWidget
    let promoWidgets = state.promoWidgets
    //console.log("sddsv", props.promoWidgets.length)
    if (props.promoWidgets.length > 0) {
      if (
        props.promoWidgets.length !== state.promoWidgets.length ||
        props.promoWidgets[0].btnImageUrl !== state.promoWidgets[0].btnImageUrl
      ) {
        //console.log("its true");
        timeO = true
        currentPromo = props.promoWidgets[0]
        promoWidgets = props.promoWidgets
      }
    }
    return {
      timeoutIn: timeO,
      currentPromoWidget: currentPromo,
      promoWidgets,
    }
  }*/

    shouldShowWidget_ForTheKnow(widget) {
      if (!widget || !widget.widgetTypeName) {
          return false;
      }
  
      if (widget.widgetTypeName === "The Know(Join The Know)") {
          return this.props.externalSignIn && !this.props.externalSignIn.memberId;
      } else if (widget.widgetTypeName === "The Know(Already Joined)") {
          return this.props.externalSignIn && this.props.externalSignIn.memberId;
      }
  
      return false;
  }
  
  setDataAvilable = () => {
    const filterPromoWidgets = () => {
        return this.props.promoWidgets.filter(widget => {
            if (widget.widgetTypeName === "The Know(Join The Know)" || widget.widgetTypeName === "The Know(Already Joined)") {
                return this.shouldShowWidget_ForTheKnow(widget); 
            }
            return true;
        });
    };

    const filteredWidgets = filterPromoWidgets();
    console.log("Filtered Widgets:", filteredWidgets);

    this.setState({ dataAvailable: false, promoWidgets: filteredWidgets }, () => {
        this.getPromoWidget(0);
    });
};
  
  getPromoWidget = (index) => {
    let timeoutInstance;
    console.log('Timer: ', index);
    // console.log('this.props.promoWidgets.length: ', this.props.promoWidgets.length);

    if(window.isTablet){
      console.log("tablet")
      this.setState({ currentPromoWidget: this.state.promoWidgets[index] });
      this.findMatch(this.state.promoWidgets[index],"widgetMatch");
      if (this.state.promoWidgets.length > index+1) {
          this.setState({ secondPromoWidget: this.state.promoWidgets[index+1] });
          this.findMatch(this.state.promoWidgets[index+1],"secondWidgetMatch");
          if (this.state.promoWidgets.length === index + 2) {
              timeoutInstance = setTimeout(
                  () => { 
                    this.getPromoWidget(0);
                   },
                  parseInt(this.state.promoWidgets[index].totalDuration) * 1000
              );
          } else {
              timeoutInstance = setTimeout(
                  () => { 
                    this.getPromoWidget(index + 2);
                  },
                  parseInt(this.state.promoWidgets[index].totalDuration) * 1000
              );
          }
      }else{
        if(this.state.promoWidgets.length !== 1){
          this.setState({ secondPromoWidget: this.state.promoWidgets[0] });
          timeoutInstance = setTimeout(
              () => { this.getPromoWidget(0) },
              parseInt(this.state.promoWidgets[index].totalDuration) * 1000
          );
        }
      }
    }else{
      let promoWidgetInstance = this.state.promoWidgets[index];
      this.setState({ currentPromoWidget: promoWidgetInstance });
      this.findMatch(this.state.promoWidgets[index],"widgetMatch");
      if (this.state.promoWidgets.length > index) {
        if (this.state.promoWidgets.length === index + 1) {
            timeoutInstance = setTimeout(
            () => { 
              this.getPromoWidget(0);
            },
            parseInt(this.state.promoWidgets[index].totalDuration) * 1000
          );
        } else {
            timeoutInstance = setTimeout(
              () => {
                if(this.state.promoWidgets.length>index+1){
                  console.log('this Match', this.state.promoWidgets.length)
                  this.getPromoWidget(index + 1)
                }
              },
              parseInt(this.state.promoWidgets[index].totalDuration) * 1000
          );
        }
      }
    }
  }

  onNavItemClick = (widget) => {
    // this.props.currentWidget(widget);
    console.log("widget-", widget);
    try {
      if (widget.widgetType === "App Launcher") {
        this.launcher(widget);
      }
      else if (widget.widgetType === "URL Renderer – Logged in") {
        console.log("url renderer – Logged in", widget.targetUrl);
        let room = localStorage.getItem("room");

        if (!room || room === "null") {
          if(process.env.REACT_APP_INROOMTAB == "true") {
            this.props.setLoginRequired(true)
          } else {
              this.props.setRegPage(true);
          }
          console.log("room", room);
          return;
        }
        //window.open(widget.targetUrl);

        if (widget.targetUrl) {
          // this.props.currentWidget(widget);
          inAppBrowser(widget.targetUrl,this.props,false, widget)
        }
      }
      else if (widget.widgetType === "URL Renderer") {
        console.log("url renderer!!!", widget.targetUrl);
        //window.open(widget.targetUrl);

        if (widget.targetUrl) {          
           // this.props.currentWidget(widget);
          inAppBrowser(widget.targetUrl,this.props,false, widget)
        }
      }
      else if (widget.widgetType === "The Know(Already Joined)") {
        console.log("The Know(Already Joined)!!!", widget.targetUrl);
        //window.open(widget.targetUrl);

        if (widget.targetUrl) {          
           // this.props.currentWidget(widget);
          inAppBrowser(widget.targetUrl,this.props,false, widget)
        }
      }
      else if (widget.widgetType === "Hotel Guide") {
        console.log("Hotel Guide", `${CMSPath}${widget.targetUrl}`);
        if (widget.targetUrl) {
          // this.props.currentWidget(widget);
          inAppBrowser(widget.targetUrl,this.props,false, widget)
        }
      }
      else if (widget.compName === "Door Camera") {
        console.log("called the door camera");
        if (this.props.streamingUrlFromConfig) {
          playDoorCameraStream(this.props.streamingUrlFromConfig, this.props);
        } else {
          console.log("URL is not there in client config.");
          this.props.popupOpenClose(true, "This functionality temporarily not available.");
        }
      }
      else {
        if(widget.widgetType === "Hcommerce"){
          this.props.setHcommerceWidget(widget);
        }
        // For rest of the all widgets
        this.props.currentWidget(widget);
        console.log('widget from promowidget of marketplace',widget)
      }

    } catch (errorMsg) {
      console.log("error in on click", errorMsg);
    }
  }

  /**
   * Below function use to select widget from complist.
   */
  findMatch = (promoWidget,match) => {

    if(!promoWidget || !match){
      return;
    }

    let promoWidgetType = promoWidget.widgetType.toLowerCase();
    // console.log('navItemsConstant', navItemsConstant);
    navItemsConstant.map((iterator) => {
      iterator.alterNativeName.map((item) => {
        if (promoWidgetType === item) {
          this.setState({ [match]: iterator })
        }
      })
    })
  }

    componentDidMount(){
        this.setDataAvilable();
        console.log("data avail")
        // this.findMatch(this.state.currentPromoWidget,"widgetMatch");
    }
    
    componentDidUpdate(prevProps){
      if(prevProps.promoWidgets !== this.props.promoWidgets){
        this.setDataAvilable();
      }
    }

  render() {
    // console.log('this.props.promoWidgets', this.props.promoWidgets, this.state.dataAvailable);
    // let promoWidgetType = this.state.currentPromoWidget.widgetType.toLowerCase();
    /*if (this.state.dataAvailable && (this.props.promoWidgets.length > 0)) {
      this.setDataAvilable();
      console.log("data avail")
      this.findMatch(this.state.currentPromoWidget,"widgetMatch");
    }*/

    // console.log('this.state.widgetMatch', this.state.widgetMatch)

    
    return (
      <div class="widgets promo-widgets">
        <div class="social-media-gallery">
          <div class="sm-img-post tile-container">
            <div class="sm-img">
              {

                this.state.widgetMatch.path ?                
                  <HashRouter>
                    <Link exact to={this.state.widgetMatch.path}
                      onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                    >
                      {
                        this.state.currentPromoWidget.btnImageUrl ?
                         <div class="image">

                           <img
                              // src={`${CMSPath}${this.state.currentPromoWidget.btnImageUrl}`}
                              src={getCdnUrl(CMSPath, this.state.currentPromoWidget.btnImageUrl)}
                              alt=""
                              onLoad={this.loadDone}
                            />
                         </div> 
                          :
                          <div class="image">
                            <img
                              // onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                              src={require('../../../images/promos/promo_default.png')}
                              onLoad={this.loadDone}
                              alt="" />
                            </div>
                      }
                      {
                         this.state.currentPromoWidget.widgetTitle &&
                         <div class="heading" dangerouslySetInnerHTML={{__html:this.state.currentPromoWidget.widgetTitle}}></div>
                      }
                      {
                         this.state.currentPromoWidget.widgetDesc &&
                         <div class="subheading"  dangerouslySetInnerHTML={{__html:this.state.currentPromoWidget.widgetDesc}}></div>
                      }
                     {
                      this.state.currentPromoWidget.buttonTitle && <div class="controls">
                          <a class="button btn-action primary" dangerouslySetInnerHTML={{__html:this.state.currentPromoWidget.buttonTitle}}>

                          </a>
                      </div>
                     }

                    </Link>
                  </HashRouter>
                  :
                  // console.log("we are in else", this.state.currentPromoWidget)
                  this.state.currentPromoWidget.btnImageUrl ?
/* TODO:
    render() {
        let match = false;
        let secondMatch = false; 
        console.log("this.props.promoWidgets",this.props.promoWidgets)
        if (this.state.dataAvailable && (this.props.promoWidgets.length > 0)) {
            this.setDataAvilable();
            // console.log("data avail")
        }

        



        return (
            <div class="widgets">
                <div class="social-media-gallery">
                   
                   <div class="sm-img-post tile-container" >
                        <div class="sm-img">
                            {                                
                                this.props.navList.map((iterator) => {
                                    // console.log("Iterator =", iterator.widgetType, this.state.currentPromoWidget);

                                    if (!match && (this.state.currentPromoWidget.widgetType === iterator.widgetType)) {
                                        match = true;
                                        // console.log("match found=", iterator);
                                        const promoComp =  (this.state.currentPromoWidget.btnImageUrl ?
                                            <img
                                                src={`${CMSPath}${this.state.currentPromoWidget.btnImageUrl}`}
                                                alt=""
                                                onLoad={this.loadDone}
                                            />
                                            :
                                            <img
                                                // onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                                                src={require('../../../images/promos/promo_default.png')}
                                                onLoad={this.loadDone}
                                                alt="" />)
                                                
                                            return (
                                                
                                                iterator.path ?
                                                <HashRouter>
                                                    <Link exact to={iterator.path} 
                                                        onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                                                    >
                                                        {promoComp}
                                                    </Link>
                                                </HashRouter>
                                                : <a onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}>
                                                    {promoComp}
                                                </a>
                                            )
                                    } else if (!match && (this.state.currentPromoWidget.widgetType === "URL Renderer – Logged in" || this.state.currentPromoWidget.widgetType === "URL Renderer")) {
                                        match = true
                                        if (this.state.currentPromoWidget.btnImageUrl) {
                                            return (
                                                <img
                                                    onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                                                    src={`${CMSPath}${this.state.currentPromoWidget.btnImageUrl}`}
                                                    alt=""
                                                // onLoad={this.loadDone}
                                                />
                                            )
                                        } else {
                                            return (
                                                <img
                                                    onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                                                    src={require('../../../images/promos/promo_default.png')}
                                                    // onLoad={this.loadDone}
                                                    alt="" />
                                            )
                                        }
                                    }
                                }) */

                  <>
                   <div class="image">
                    <img
                      onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                      src={`${CMSPath}${this.state.currentPromoWidget.btnImageUrl}`}
                      alt=""
                    // onLoad={this.loadDone}
                    />
                    </div>
                    {
                      this.state.currentPromoWidget.widgetTitle &&
                      <div class="heading" dangerouslySetInnerHTML={{__html:this.state.currentPromoWidget.widgetTitle}}></div>
                   }
                   {
                      this.state.currentPromoWidget.widgetDesc &&
                      <div class="subheading"  dangerouslySetInnerHTML={{__html:this.state.currentPromoWidget.widgetDesc}}></div>
                   }
                  {
                   this.state.currentPromoWidget.buttonTitle && <div class="controls">
                       <a class="button btn-action primary" dangerouslySetInnerHTML={{__html:this.state.currentPromoWidget.buttonTitle}}>

                       </a>
                   </div>
                  }
                  </>
                    :
                    <img
                      onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                      src={require('../../../images/promos/promo_default.png')}
                      // onLoad={this.loadDone}
                      alt="" />
              }
              {/* <div class="sm-img-text">
                                Wish you were here
                            </div> */}
            </div>
            {/* <a href="javascript:void(0);" class="edit bottom-right"><i class="fas fa-pen fa-flip-horizontal"></i></a> */}
          </div>
          { window.isTablet && this.state.secondPromoWidget && this.state.secondWidgetMatch &&
            <div class="sm-img-post tile-container">
              <div class="sm-img">
                {

                  this.state.secondWidgetMatch.path ?
                    <HashRouter>
                      <Link exact to={this.state.secondWidgetMatch.path}
                        onClick={() => { this.onNavItemClick(this.state.secondPromoWidget) }}
                      >
                        {
                          this.state.secondPromoWidget.btnImageUrl ?
                            <img
                              src={`${CMSPath}${this.state.secondPromoWidget.btnImageUrl}`}
                              alt=""
                              onLoad={this.loadDone}
                            />
                            :
                            <img
                              // onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                              src={require('../../../images/promos/promo_default.png')}
                              onLoad={this.loadDone}
                              alt="" />
                        }
                      </Link>
                    </HashRouter>
                    :
                    // console.log("we are in else", this.state.currentPromoWidget)
                    this.state.secondPromoWidget.btnImageUrl ?

                      <img
                        onClick={() => { this.onNavItemClick(this.state.secondPromoWidget) }}
                        src={`${CMSPath}${this.state.secondPromoWidget.btnImageUrl}`}
                        alt=""
                      // onLoad={this.loadDone}
                      />
                      :
                      <img
                        onClick={() => { this.onNavItemClick(this.state.secondPromoWidget) }}
                        src={require('../../../images/promos/promo_default.png')}
                        // onLoad={this.loadDone}
                        alt="" />
                }
                
              </div>
            </div>
          }
          {/* <div class="controls share">
                    <a href="javascript:void(0)" class="button btn-fb tile-container"><i class="fab fa-facebook-f"></i> Share</a>
                    <a href="javascript:void(0)" class="button btn-twitter tile-container"><i class="fab fa-twitter"></i> Share</a>
                </div> */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    //
    streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
      state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
    navList: state.store.sideNavBar.navItems,
    menuColor: state.store.home.MenuColor,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentWidgets: state.store.sideNavBar.currentWidget,
    currentHomePage: state.store2.currentHomePage,
    openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
    externalSignIn: state.store2.externalSignIn,
  }
}

PromoWidget.propTypes = {
  promoWidget: propTypes.object
}

export default connect(
  mapStateToProps,
  {
    setRegPage,
    browserListPopup,
    currentWidget,
    popupOpenClose,
    setHcommerceWidget,
    setDeviceConfigFailed,
    sendAnalytics,
    setLoader,
    setFailScreen,
    setLoginRequired,
    setOpenExternalLinkInSameTab,
    setExternalSignIn
  }
)(PromoWidget);